
import { computed, defineComponent, ref, watch } from "vue";
import { storeUtil } from "@/store";
import { metanodeUtil } from "@/util/metanode";
import CopyButton from "@/components/UI/CopyButton.vue";
import ImageLoader from "@/components/UI/ImageLoader.vue";
import Modal from "@/components/UI/Modal.vue";
import SendNft from "@/components/SendNft.vue";
import BananoShape from "@/components/UI/BananoShape.vue";
import { Asset, BanAccount } from "@/types";
import { bananoUtil } from "@/util/banano";

export default defineComponent({
  name: "Account",
  props: {
    address: {
      type: String,
      required: true,
    },
  },
  components: {
    CopyButton,
    ImageLoader,
    Modal,
    SendNft,
    BananoShape,
  },

  setup(props) {
    const seed = computed(storeUtil.getters.seed);
    const accounts = computed(storeUtil.getters.accounts);
    const accountIndex = computed(() =>
      accounts.value.findIndex((acc) => acc.address === props.address)
    );
    const account = ref<BanAccount>();

    const loadAccount = async () => {
      console.log(`Loading ${props.address}`);

      if (accountIndex.value !== -1)
        account.value = accounts.value[accountIndex.value];
      else {
        account.value = await bananoUtil.getAccount(props.address);
      }
    };
    loadAccount();
    watch([accountIndex, () => props.address], loadAccount);

    const nfts = ref<Asset[]>();
    const loadingNfts = ref(true);

    const loadNfts = async () => {
      console.log(`Loading ${props.address} assets`);

      nfts.value = [];
      loadingNfts.value = true;
      let res = await metanodeUtil.getAssetsOwnedByAccount(props.address);
      loadingNfts.value = false;
      nfts.value = res;
    };
    loadNfts();
    watch(() => props.address, loadNfts);

    const getImageUrl = (cid: string) =>
      new URL(cid, metanodeUtil.ipfsUrl).toString();

    const sendNftAsset = ref<string>();
    const closeModal = () => {
      sendNftAsset.value = undefined;
    };

    const receiveNftAsset = async (nft: Asset) => {
      nft.receiving = true;
      if (!nft.history) return;

      nft.history[nft.history.length - 1].receive = (
        await bananoUtil.receiveBlock(
          seed.value,
          accountIndex.value,
          nft.history[nft.history.length - 1].send,
          account.value?.representative
        )
      ).receiveBlocks[0];

      nft.received = "true";
      nft.receiving = false;
    };

    return {
      account,
      accountIndex,
      nfts,
      loadingNfts,
      sendNftAsset,
      getImageUrl,
      closeModal,
      receiveNftAsset,
      loadNfts,
    };
  },
});
